module.exports = __webpack_public_path__ + "img/bag2.81173ab6.png";